export function svgMask(url, color = 'currentColor') {
  return {
    mask: `url(${url}) no-repeat center / contain`,
    WebkitMask: `url(${url}) no-repeat center / contain`,
    backgroundColor: color,
    display: 'inline-block',
  }
}